module.exports = __webpack_public_path__ + "static/media/img2.8e7b5a2c.jpg";